import { render } from "./App.vue?vue&type=template&id=6d941705&lang=pug"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6d941705&lang=css"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__